import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=be114270&scoped=true"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=be114270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be114270",
  null
  
)

export default component.exports